export const DEFAULT_DESKTOP_PREFERENCES = Object.freeze({
    theme: 'dark', chatFont: 'system', motion: 'system', windowPlacement: 'mascot', accent: 'gyro',
    displayName: '', nickname: '', work: '', responseNotifications: true, allowSharing: true,
    responseMode: 'balanced', knowledgeMode: 'work', showTokenCounter: true,
});
export function desktopPreferencesKey(appKey, userKey) {
    return `${appKey}-gyro-desktop-preferences-v1-${userKey}`;
}
export function normalizeDesktopPreferences(value) {
    const source = value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    const choice = (key, choices, fallback) => typeof source[key] === 'string' && choices.includes(source[key]) ? source[key] : fallback;
    const text = (key, max) => typeof source[key] === 'string' ? source[key].slice(0, max) : '';
    return {
        theme: choice('theme', ['system', 'dark', 'light'], 'dark'),
        chatFont: choice('chatFont', ['system', 'serif', 'mono'], 'system'),
        motion: choice('motion', ['system', 'reduced'], 'system'),
        windowPlacement: choice('windowPlacement', ['mascot', 'left', 'right', 'free'], 'mascot'),
        accent: choice('accent', ['gyro', 'blue', 'neutral'], 'gyro'),
        responseMode: choice('responseMode', ['fast', 'balanced', 'high', 'deep', 'ultra'], 'balanced'),
        knowledgeMode: choice('knowledgeMode', ['work', 'world'], 'work'),
        displayName: text('displayName', 100), nickname: text('nickname', 60), work: text('work', 120),
        responseNotifications: typeof source.responseNotifications === 'boolean' ? source.responseNotifications : true,
        allowSharing: typeof source.allowSharing === 'boolean' ? source.allowSharing : true,
        showTokenCounter: typeof source.showTokenCounter === 'boolean' ? source.showTokenCounter : true,
    };
}
export function readDesktopPreferences(storage, key) {
    try {
        return normalizeDesktopPreferences(JSON.parse(storage?.getItem(key) || 'null'));
    }
    catch {
        return { ...DEFAULT_DESKTOP_PREFERENCES };
    }
}
export function saveDesktopPreferences(storage, key, value) {
    if (!storage)
        return false;
    try {
        storage.setItem(key, JSON.stringify(normalizeDesktopPreferences(value)));
        return true;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=desktopPreferences.js.map